export default function removeDatetimeOffset(datetime: string) {
    let tzPartStart = datetime.lastIndexOf('+')
    if (tzPartStart === -1) {
        tzPartStart = datetime.lastIndexOf('-')
    }
    return datetime.slice(0, tzPartStart)
}
